/**
 * Created by yiren on 2019-08-29
 * History
 */

import React from "react";
import style from "./style.css";
import { contractCall } from "../config/api";
import { Toast, List } from "antd-mobile";
import {getContractAddress, getFromAddress} from "../tool/lstool";


const { Item } = List;
const { Brief } = Item;

export default class ClosedProposal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      contractAddress: getContractAddress()
    };
  }

  componentDidMount() {
    this.getHistory();
    if (!this.state.contractAddress) {
      Toast.info('请先设置合约地址');
      this.props.history.push('/contract');
    }
  }

  async getHistory() {
    Toast.loading();
    try {
      let proposalArray = [];

      let param = `{"from":"n1STxGuEZaneTtNiXoVLD8TdmSk48Erfvnd","to":"${this.state.contractAddress}","value":"0","gasPrice":"20000000000","gasLimit":"2000000","contract":{"function":"getClosedProposal","args":"[]"}}`;
      console.log(param);
      const data = await contractCall(JSON.parse(param));

      if (data.result.result == "{}") {
        Toast.info("列表为空", 1);
        return;
      }

      let info = JSON.parse(data.result.result);

      for (let index in info) {
        proposalArray.push(info[index]);
      }

      this.setState({
        history: proposalArray
      });

      this.setList(proposalArray);
      console.log(proposalArray);
      Toast.hide();
    } catch (e) {
      Toast.hide();
      console.log(e);
    }
  }

  setList = list => {
    let ItemList = [];
    for (let index in list) {
      let keys = Object.keys(list[index].vote);
      let voters = "";
      for (let i in keys) {
        let str = keys[i].slice(-5);
        voters = voters + str + ": ";

        if (list[index].vote[keys[i]] == "0") {
          voters = voters + "NO  ";
        } else {
          voters = voters + "YES  ";
        }
      }

      ItemList.push(
        <Item>
          <div className={style.cellContainer}>
            <div className={style.indexContainer}>
              <span
                className={style.textSpanBold}
              >{`Index ${list[index].index}`}</span>
            </div>
            <div className={style.middleContainer}>
              <div>
                <span className={style.textSpan}>Amount:</span>{" "}
                <span
                  className={style.textSpanBold}
                >{`${list[index].amount}`}</span>{" "}
                <span className={style.textSpan}>To Address:</span>{" "}
                <span
                  className={style.textSpanBold}
                >{` ${list[index].toAddress}`}</span>
              </div>
              <div style={{ marginTop: "10px" }}>
                <span className={style.textSpan}>Voted By:</span>
                <span className={style.textSpan}>{`${voters}`}</span>{" "}
              </div>
              <div>
                <span
                  className={style.textSpan}
                >{`Notes: ${list[index].note}`}</span>
              </div>
            </div>
            <div className={style.rightContainer}>
              <span
                style={
                  list[index].status == "Declined"
                    ? { color: "red" }
                    : { color: "black" }
                }
              >
                {list[index].status}
              </span>
            </div>
          </div>
        </Item>
      );
    }

    this.setState({
      list: ItemList
    });
  };

  render() {
    return (
      <div className={style.container}>
        <h2>历史提案</h2>
        <div
          style={{
            width: "100%",
            height: "1px",
            backgroundColor: "rgba(0,0,0,0.6)"
          }}
        />
        <List style={{ backgroundColor: "rgb(243,243,248)" }}>
          {this.state.list}
        </List>
      </div>
    );
  }
}
